export default __webpack_public_path__ + "static/arrow-blue-mobile-nav-1996d4a564e846e0762f4e937e1d8993.png";